// HL-12234: the UK funnel never mentions Care+, and the Care+ shipping FAQ explains Care+ ("What is Care+?").
export const showsCarePlusShippingFAQ = (country: string | null | undefined): boolean =>
  String(country ?? "").toUpperCase() !== "GB";
